import { render, staticRenderFns } from "./menu-contentBlock.vue?vue&type=template&id=94275f20&scoped=true&"
import script from "./menu-contentBlock.vue?vue&type=script&lang=js&"
export * from "./menu-contentBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94275f20",
  null
  
)

export default component.exports